module.exports = __webpack_public_path__ + "static/AI-Governance-in-2019-7795369fd451da49ae4471ce9d648a45.pdf";